import React from 'react';
import { IonIcon } from '@ionic/react';
import { ticketOutline, linkOutline } from 'ionicons/icons';
import './TicketTitleRow.css';

const getIssueTypeColor = (issueTypeName) => {
  const name = (issueTypeName || '').toLowerCase();
  if (name.includes('story')) return '#4bce97';
  if (name.includes('bug')) return '#f87168';
  if (name.includes('task')) return '#579dff';
  if (name.includes('epic')) return '#9f8fef';
  if (name.includes('subtask')) return '#6b778c';
  if (name.includes('feature')) return '#4bce97';
  return '#6b778c';
};

const TicketTitleRow = ({ title, issueType, icon, jiraUrl, actions, titleDiff }) => {
  return (
    <div className="shared-ticket-header">
      <div className="shared-ticket-title-section">
        <div className="shared-ticket-title-row">
          {icon ? (
            <IonIcon 
              icon={icon} 
              className="shared-ticket-type-icon"
            />
          ) : issueType?.iconUrl ? (
            <img 
              src={issueType.iconUrl.replace('size=medium', 'size=xlarge')}
              alt={issueType?.name}
              className="shared-ticket-type-icon"
            />
          ) : (
            <IonIcon 
              icon={ticketOutline} 
              className="shared-ticket-type-icon"
              style={{ color: getIssueTypeColor(issueType?.name) }}
            />
          )}
          {titleDiff || <h1 className="shared-ticket-title">{title}</h1>}
          {jiraUrl && (
            <a
              href={jiraUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="shared-ticket-jira-link"
            >
              <IonIcon icon={linkOutline} />
              <span className="instant-tooltip">Go to Jira ticket</span>
            </a>
          )}
          {actions && <div className="shared-ticket-title-actions">{actions}</div>}
        </div>
      </div>
    </div>
  );
};

export default TicketTitleRow;
